<div class="dashboard">
  <p-tabs
    scrollable
    value="0"
    class="engagementDash"
    (onChange)="onTabChange($event)">
    <p-tablist>
      <p-tab value="0">Milestone 1 Payment Schedule</p-tab>
      <p-tab value="1">Milestone 2 Payment Schedule</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <app-payment-schedule-milestone1></app-payment-schedule-milestone1>
      </p-tabpanel>
      <p-tabpanel value="1">
        <app-payment-schedule-milestone2></app-payment-schedule-milestone2>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
